<div class="static-desktop-heading">
  {{ 'ownStrategies.header' | translate }}
</div>

<div class="desktop-aligment">
  <div class="desktop-image-container desktop-image-container--owned-strategies" background></div>

  <div class="desktop-column">
    <div class="static-heading">
      {{ 'ownStrategies.subHeader' | translate }}
    </div>

    <div class="static-text" [innerHTML]="'ownStrategies.text1' | translate | htmlFormat"></div>

    <div class="phone-image-container">
      <img src="/assets/images/static-pages/foto-vlastni-strategie.jpg" alt="own strategies banner">
    </div>

    <div class="static-text" [innerHTML]="'ownStrategies.text2' | translate | htmlFormat"></div>
  </div>
</div>

<libero-static-page-footer></libero-static-page-footer>
